import { useLanguage } from '@/i18n/LanguageContext';
import { Language } from '@/i18n/translations';
import { Globe } from 'lucide-react';
import { useState } from 'react';

const LanguageSwitcher = () => {
  const { language, setLanguage, languages, dir } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const languageFlags: Record<Language, string> = {
    en: '🇬🇧',
    es: '🇪🇸',
    pt: '🇧🇷',
    zh: '🇨🇳',
    fr: '🇫🇷',
    ar: '🇸🇦',
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 border border-border/30 hover:border-border transition-all text-xs rounded-md"
        aria-label="Change language"
      >
        <Globe className="w-3 h-3" />
        <span>{languageFlags[language]}</span>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)} 
          />
          <div className={`absolute top-full mt-2 z-50 bg-background border border-border/30 min-w-[160px] shadow-lg rounded-md overflow-hidden ${dir === 'rtl' ? 'left-0' : 'right-0'}`}>
            {(Object.keys(languages) as Language[]).map((lang) => (
              <button
                key={lang}
                onClick={() => {
                  setLanguage(lang);
                  setIsOpen(false);
                }}
                className={`w-full px-4 py-3 text-sm flex items-center gap-3 hover:bg-foreground/5 transition-colors ${
                  language === lang ? 'bg-foreground/10' : ''
                } ${lang === 'ar' ? 'text-right' : 'text-left'}`}
                dir={lang === 'ar' ? 'rtl' : 'ltr'}
              >
                <span>{languageFlags[lang]}</span>
                <span>{languages[lang]}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
